// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.headerAccount = function () {
  /**
   * @var {Record<string, string>}
   * A list of classes used as CSS styling hooks
   */
  const classes = {
    accountOpen: "is-account",
  };

  /**
   * @param {HTMLElement}
   */
  const openButtons = document.querySelectorAll("[data-js-open-account]");

  /**
   * @param {HTMLElement}
   */
  const closeButton = document.querySelector("[data-js-close-account]");

  /**
   * @param {HTMLDialogElement | null}
   * the modal of the account
   */
  const modal = document.querySelector("[data-js-account]");

  /**
   * Work out whether to show/hide the account form modal based on its current status
   * when the toggle button is clicked
   *
   * @returns {void}
   */
  const handleOpenButtonClick = (event) => {
    event.preventDefault();

    const isExpanded = openButtons[0]
      ?.getAttribute("aria-expanded")
      ?.toString();

    if (isExpanded === "true") {
      close();
    } else {
      open();
    }
  };

  /**
   * Open the account modal
   *
   * @returns {void}
   */
  const open = () => {
    if (window.AndDaughter.headerScroll) {
      document.documentElement.classList.add(
        window.AndDaughter.headerScroll().classes.scrollDowned
      );
    }
    document.documentElement.classList.add(classes.accountOpen);

    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i]?.setAttribute("aria-expanded", "true");
    }

    modal?.show();

    // Close the open cart
    if (window.AndDaughter.cartDrawer) {
      window.AndDaughter.cartDrawer().close();
    }
  };

  /**
   * Close the opened account modal
   *
   * @returns {void}
   */
  const close = () => {
    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i]?.setAttribute("aria-expanded", "false");
    }
    modal?.close();
    document.documentElement.classList.remove(classes.accountOpen);
  };

  /**
   * Handle keydown events, only used to handle Esc key which should close the modal
   * @param {KeyboardEvent} event
   *
   * @return {void}
   */
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // if esc key was not pressed in combination with ctrl or alt or shift
      const isCombinedKey = event.ctrlKey || event.altKey || event.shiftKey;
      if (!isCombinedKey && modal?.open) {
        close();
        for (let i = 0; i < openButtons.length; i++) {
          if (openButtons[i]?.checkVisibility()) {
            openButtons[i]?.focus();
            break;
          }
        }
      }
    }
  };

  /**
   * Detects a click outside the component (when it's active)
   * @param {Event} event
   *
   * @return {void}
   */
  const handleOutsideClick = (event) => {
    if (
      !modal?.open ||
      (event.target?.closest("a") &&
        event.target?.closest("a").getAttribute("aria-controls") ===
          "account-popup")
    ) {
      return;
    }

    const isClickInside = modal?.contains(event.target);

    if (!isClickInside) {
      close();
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    if (!modal || !openButtons || openButtons.length === 0 || !closeButton) {
      return;
    }

    // Open
    for (let i = 0; i < openButtons.length; i++) {
      openButtons[i].setAttribute("aria-expanded", "false");
      openButtons[i].setAttribute("aria-controls", "account-popup");
      openButtons[i].removeEventListener("click", handleOpenButtonClick);
      openButtons[i].addEventListener("click", handleOpenButtonClick);
    }

    // Click/tap close = close
    closeButton.removeEventListener("click", close);
    closeButton.addEventListener("click", close);

    // Press Esc = close
    document.removeEventListener("keydown", handleKeyDown);
    document.addEventListener("keydown", handleKeyDown);

    // Click outside the cart to close it
    document.removeEventListener("click", handleOutsideClick);
    document.addEventListener("click", handleOutsideClick);
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    addEventListeners();
  };

  return {
    close,
    init,
  };
};

window.AndDaughter.headerAccount().init();
